<div style="width: 100%">
    <mat-form-field style="width: 100%">
        <mat-label>H&auml;ndler ausw&auml;hlen</mat-label>
        <mat-select [formControl]="formControl" [compareWith]="haendlerComparator">
            <mat-option>Kein H&auml;ndler</mat-option>
            <mat-option *ngFor="let h of haendler" [value]="h">{{ h.name }} - {{ h.ort }} - {{ h.vvvo }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
